import { apiClient } from '@/services/Axios';
import { toLegacyDetail, toLegacyPaginated, unwrapV1, v1Delete, v1Get, v1Post, v1Put } from '@/services/v1Api';

export const getContacts = async (page = 1, perPage = 50) => {
    try {
        const { data, meta } = await v1Get('/api/v1/address-book/contacts', {
            page,
            per_page: perPage,
        });
        return toLegacyPaginated(data, meta);
    } catch (error) {
        console.error('Error fetching contacts:', error);
        throw error;
    }
};

export const getContactsByLetter = async (letter = null) => {
    try {
        const params = {};
        if (letter) params.letter = letter;
        const { data, meta } = await v1Get('/api/v1/address-book/contacts', params);
        return toLegacyPaginated(data, meta);
    } catch (error) {
        console.error('Error fetching contacts by letter:', error);
        throw error;
    }
};

export const fetchContactById = async (id) => {
    try {
        const { data } = await v1Get(`/api/v1/address-book/contacts/${id}`);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error fetching contact by ID:', error);
        throw error;
    }
};

export const createContact = async (contactData) => {
    try {
        const { data } = await v1Post('/api/v1/address-book/contacts', contactData);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error creating contact:', error);
        throw error;
    }
};

export const updateContact = async (id, contactData) => {
    try {
        const { data } = await v1Put(`/api/v1/address-book/contacts/${id}`, contactData);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error updating contact:', error);
        throw error;
    }
};

export const deleteContact = async (id) => {
    try {
        await v1Delete(`/api/v1/address-book/contacts/${id}`);
        return { success: true };
    } catch (error) {
        console.error('Error deleting contact:', error);
        throw error;
    }
};

// Upload profile image
export const uploadContactImage = async (contactId, imageFile) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);

        const response = await apiClient.post(
            `/api/v1/address-book/contacts/${contactId}/upload-image`,
            formData
        );
        const { data } = unwrapV1(response);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error uploading contact image:', error);
        throw error;
    }
};

// Upload document
export const uploadContactDocument = async (contactId, file, name, documentType = null) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', name);
        if (documentType) {
            formData.append('document_type', documentType);
        }

        const response = await apiClient.post(
            `/api/v1/address-book/contacts/${contactId}/documents`,
            formData
        );
        const { data } = unwrapV1(response);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error uploading contact document:', error);
        throw error;
    }
};

// Download document
export const downloadContactDocument = async (contactId, documentId) => {
    try {
        const response = await apiClient.get(
            `/api/v1/address-book/contacts/${contactId}/documents/${documentId}/download`,
            {
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error downloading contact document:', error);
        throw error;
    }
};

// Delete document
export const deleteContactDocument = async (contactId, documentId) => {
    try {
        await v1Delete(
            `/api/v1/address-book/contacts/${contactId}/documents/${documentId}`
        );
        return { success: true };
    } catch (error) {
        console.error('Error deleting contact document:', error);
        throw error;
    }
};
